import BookingService from '../api/booking-service'

export default {
    state: {
        error: null,
        bookingResults: [],
        bookingDetail: null,
        customer: {
            title: null,
            firstName: null,
            surname: null,
            email: null,
            mobilePhone: null,
            postcode: null,
            outboundFlight: null,
            inboundFlight: null,
            hasRequestedMarketing: false
        },
        getCustomerDetailsLoading: false,
        vehicle: {},
        flightDetails: null,
        paymentDetail: null,
        product: null,
        productExtras: [],
        bookingHistory: [],
        notes: [],
        refundDetails: null,
        paymentHistory: [],
        audit: [],
        booking: null,
        newBookingFormValid: false,
        entryAndExit: {
            entryDate: null,
            entryTime: null,
            entryDateTime: null,
            exitDate: null,
            exitTime: null,
            exitDateTime: null,
            validSelection: false
        },
        searchParams: null,
        paymentSession: null,
        bookingCreationResponse: null,
        bookingReserveResponse: null,
        bookingConfirmResponse: null,
        promotion: {
            code: null,
            valid: false,
            pending: true
        },
        bookingType: null,
        cancellationDetails: null,
        cancellationCharge: 7.5,
        overridePrice: 0,
        priceOverriden: false,
        overrideParkingProductPrice: 0
    },
    mutations: {
        setGetCustomerDetailsLoading (state, loading) {
            state.getCustomerDetailsLoading = loading
        },
        updateBookingResults (state, bookings) {
            state.bookingResults = bookings
        },
        clearBookings (state) {
            state.bookingResults = []
        },
        setError (state, error) {
            state.error = error
        },
        clearBookingData (state) {
            state.bookingDetail = null
            state.customer = null
            state.vehicle = {
                registration: null
            }
            state.flightDetails = null
            state.paymentDetail = null
            state.product = null
            state.productExtras = []
            state.bookingHistory = []
            state.notes = []
            state.paymentHistory = []
            state.audit = []
            state.cancellationDetails = null
            state.refundDetails = null
            state.bookingReserveResponse = null
            state.bookingConfirmResponse = null
            state.overridePrice = 0
            state.priceOverriden = false
            state.overrideParkingProductPrice = 0
        },
        setBookingDetail (state, bookingDetail) {
            state.bookingDetail = bookingDetail
        },
        setCustomer (state, customer) {
            state.customer = customer
        },
        setVehicle (state, vehicle) {
            state.vehicle = vehicle
        },
        setProduct (state, product) {
            state.product = product
        },
        setProductExtras (state, productExtras) {
            state.productExtras = productExtras
        },
        setFlightDetails (state, flightDetails) {
            state.flightDetails = flightDetails
        },
        setHistory (state, history) {
            state.bookingHistory = history
        },
        setNotes (state, notes) {
            state.notes = notes
        },
        setPaymentHistory (state, paymentHistory) {
            state.paymentHistory = paymentHistory
        },
        setPaymentDetail (state, paymentDetail) {
            state.paymentDetail = paymentDetail
        },
        setAudit (state, audit) {
            state.audit = audit
        },
        updateCustomer (state, customer) {
            state.customer = customer
        },
        updateVehicle (state, vehicle) {
            state.vehicle = vehicle
        },
        updateFlightDetails (state, [outboundFlight, inboundFlight]) {
            state.selectedBooking.outboundFlight.flightNumber = outboundFlight.flightNumber
            state.selectedBooking.inboundFlight.flightNumber = inboundFlight.flightNumber
        },
        updateBooking (state, booking) {
            state.booking = booking
        },
        updateEntryDate (state, entryDate) {
            state.entryAndExit.entryDate = entryDate
        },
        updateEntryTime (state, entryTime) {
            state.entryAndExit.entryTime = entryTime
        },
        updateExitDate (state, exitDate) {
            state.entryAndExit.exitDate = exitDate
        },
        updateExitTime (state, exitTime) {
            state.entryAndExit.exitTime = exitTime
        },
        updateEntryDateTime (state, entryDateTime) {
            state.entryAndExit.entryDateTime = entryDateTime
        },
        updateExitDateTime (state, exitDateTime) {
            state.entryAndExit.exitDateTime = exitDateTime
        },
        updateDateTimeValid (state, validSelection) {
            state.entryAndExit.validSelection = validSelection
        },
        resetEntryAndExit (state) {
            state.entryAndExit = {
                entryDate: null,
                entryTime: null,
                entryDateTime: null,
                exitDate: null,
                exitTime: null,
                exitDateTime: null,
                validSelection: false
            }
        },
        updateSearchParams (state, searchParams) {
            state.searchParams = searchParams
        },
        setPaymentSession (state, sessionUpdateResponse) {
            state.paymentSession = sessionUpdateResponse
        },
        setBookingCreationResponse (state, response) {
            state.bookingCreationResponse = response
        },
        setBookingReserveResponse (state, response) {
            state.bookingReserveResponse = response
        },
        setBookingConfirmResponse (state, response) {
            state.bookingConfirmResponse = response
        },
        setCustomerFirstName (state, value) {
            state.customer.firstName = value
        },
        setCustomerSurname (state, value) {
            state.customer.surname = value
        },
        setCustomerEmail (state, value) {
            state.customer.email = value
        },
        setCustomerMobilePhone (state, value) {
            state.customer.mobilePhone = value
        },
        setCustomerOutboundFlight (state, value) {
            state.customer.outboundFlight = value
        },
        setCustomerInboundFlight (state, value) {
            state.customer.inboundFlight = value
        },
        setCustomerHasRequestedMarketing (state, value) {
            state.customer.hasRequestedMarketing = value
        },
        setVehicleRegistration (state, value) {
            state.vehicle.registration = value
        },
        setNewBookingFormValid (state, valid) {
            state.newBookingFormValid = valid
        },
        resetBooking (state) {
            state.booking = null
            state.entryAndExit = {
                entryDate: null,
                entryTime: null,
                entryDateTime: null,
                exitDate: null,
                exitTime: null,
                exitDateTime: null,
                validSelection: false
            }
            state.customer = {
                title: null,
                firstName: null,
                surname: null,
                email: null,
                mobilePhone: null,
                postcode: null,
                outboundFlight: null,
                inboundFlight: null,
                hasRequestedMarketing: false
            }
            state.bookingCreationResponse = null
            state.paymentSession = null
            state.promotion = {
                code: null,
                valid: false,
                pending: true
            }
            state.refundDetails = null
            state.bookingReserveResponse = null
            state.bookingConfirmResponse = null
            state.priceOverriden = false
            state.overridePrice = 0
            state.overrideParkingProductPrice = 0
        },
        setPromoCode (state, promoCode) {
            state.promotion.code = promoCode
        },
        setPromoValid (state, promoValid) {
            state.promotion.valid = promoValid
            state.promotion.pending = false
        },
        setBookingType (state, bookingType) {
            state.bookingType = bookingType
        },
        setCancellationDetails (state, cancellationDetails) {
            state.cancellationDetails = cancellationDetails
        },
        setRefundDetails (state, refundDetails) {
            state.refundDetails = refundDetails
        },
        setOverridePrice (state, overridePrice) {
            state.priceOverriden = true
            state.overridePrice = overridePrice
        },
        resetOverridePrice (state) {
            state.priceOverriden = false
            state.overridePrice = 0
        },
        setOverrideParkingPrice (state, parkingProductPrice) {
            state.overrideParkingProductPrice = parkingProductPrice
        }
    },
    actions: {
        async bookingSearch (context, bookingSearch) {
            return BookingService.search(bookingSearch).then((response) => {
                context.commit('updateBookingResults', response.data)
                return response
            }).catch((error) => {
                return error.response
            })
        },
        async clearBookings (context) {
            context.commit('clearBookings')
        },
        async clearBookingData (context) {
            context.commit('clearBookingData')
        },
        async getBookingDetail (context, bookingId) {
            var response = await BookingService.getBookingDetail(bookingId)
            await context.commit('setBookingDetail', response.data)
        },
        async getCustomer (context, bookingId) {
            context.commit('setGetCustomerDetailsLoading', true)
            var response = await BookingService.getCustomer(bookingId)
            context.commit('setCustomer', response.data)
            context.commit('setGetCustomerDetailsLoading', false)
        },
        async getVehicle (context, bookingId) {
            return BookingService.getVehicle(bookingId).then((response) => {
                context.commit('setVehicle', response.data)
            })
        },
        async getFlightDetails (context, bookingId) {
            var response = await BookingService.getFlightDetails(bookingId)
            context.commit('setFlightDetails', response.data)
        },
        async getBookingHistory (context, bookingId) {
            var response = await BookingService.getBookingHistory(bookingId)
            context.commit('setHistory', response.data)
        },
        async getBarrierStatus ({ commit }, bookingId) {
            return await BookingService.getBarrierStatus(bookingId)
        },
        async getNotes (context, bookingId) {
            var response = await BookingService.getNotes(bookingId)
            context.commit('setNotes', response.data)
        },
        async getPaymentDetail (context, bookingId) {
            var response = await BookingService.getPaymentDetail(bookingId)
            context.commit('setPaymentDetail', response.data)
        },
        async getPaymentHistory (context, bookingId) {
            var response = await BookingService.getPaymentHistory(bookingId)
            context.commit('setPaymentHistory', response.data)
        },
        async getProduct (context, bookingId) {
            var response = await BookingService.getProduct(bookingId)
            context.commit('setProduct', response.data)
        },
        async getProductExtras (context, bookingId) {
            var response = await BookingService.getProductExtras(bookingId)
            context.commit('setProductExtras', response.data)
        },
        async getAudit (context, bookingId) {
            var response = await BookingService.getAudit(bookingId)
            context.commit('setAudit', response.data)
        },
        async getBookingType (context, bookingId) {
            var response = await BookingService.getBookingType(bookingId)
            context.commit('setBookingType', response.data)
        },
        async updateCustomer (context, [bookingId, customer]) {
            return BookingService.updateCustomer(bookingId, customer).then((response) => {
                return response
            }).catch((error) => {
                return error.response
            })
        },
        async addNote (context, [bookingId, note]) {
            await BookingService.addNote(bookingId, note)
        },
        async updateVehicle (context, [bookingId, vehicle]) {
            return BookingService.updateVehicle(bookingId, vehicle).then((response) => {
                return response
            }).catch((error) => {
                throw error.response
            })
        },
        async updateFlight (context, [bookingId, flightDetails]) {
            return BookingService.updateFlight(bookingId, flightDetails).then((response) => {
                return response
            }).catch((error) => {
                return error.response
            })
        },
        async updateProductDate (context, [bookingId, entryDate, exitDate]) {
            return BookingService.updateProductDate(bookingId, entryDate, exitDate).then((response) => {
                return response
            }).catch((error) => {
                return error.response
            })
        },
        async updateEntryDate (context, entryDate) {
            context.commit('updateEntryDate', entryDate)
        },
        async updateEntryTime (context, entryTime) {
            context.commit('updateEntryTime', entryTime)
        },
        async updateExitDate (context, exitDate) {
            context.commit('updateExitDate', exitDate)
        },
        async updateExitTime (context, exitTime) {
            context.commit('updateExitTime', exitTime)
        },
        async updateEntryDateTime (context, entryDateTime) {
            context.commit('updateEntryDateTime', entryDateTime)
        },
        async updateExitDateTime (context, exitDateTime) {
            context.commit('updateExitDateTime', exitDateTime)
        },
        async updateDateTimeValid (context, dateTimeValid) {
            context.commit('updateDateTimeValid', dateTimeValid)
        },
        async resetEntryAndExit (context) {
            context.commit('resetEntryAndExit')
        },
        async setCustomer (context, customer) {
            context.commit('setCustomer', customer)
        },
        async reserveBooking (context) {
            context.commit('setError', null)
            return BookingService.reserveBooking(context.state.booking).then((response) => {
                context.commit('setBookingReserveResponse', response)
                return response
            }).catch((error) => {
                context.commit('setError', error.response)
                return error.response
            })
        },
        async addExtra (context, [bookingId, extra]) {
            const response = await BookingService.addExtra(bookingId, extra)
            if (response.success) {
                context.commit('setBookingReserveResponse', response)
            }
            return response
        },
        async resetBookingReserveResponse (context) {
            context.commit('setBookingReserveResponse', null)
        },
        async setBookingReserveResponse (context, value) {
            context.commit('setBookingReserveResponse', value)
        },
        async confirmBooking (context) {
            context.commit('setError', null)
            return BookingService.confirmBooking(context.state.booking).then((response) => {
                context.commit('setBookingConfirmResponse', response)
                return response
            }).catch((error) => {
                context.commit('setError', error.response)
                return error.response
            })
        },
        async modifyBooking (context) {
            context.commit('setError', null)
            return BookingService.modifyBooking(context.state.booking).then((response) => {
                context.commit('setBookingReserveResponse', response)
                return response
            }).catch((error) => {
                context.commit('setError', error.response)
                return error.response
            })
        },
        async confirmModifyBooking (context) {
            context.commit('setError', null)
            return BookingService.confirmModifyBooking(context.state.booking).then((response) => {
                context.commit('setBookingConfirmResponse', response)
                return response
            }).catch((error) => {
                context.commit('setError', error.response)
                return error.response
            })
        },
        async setBookingCreationResponse (context, value) {
            context.commit('setBookingCreationResponse', value)
        },
        async updateSearchParams (context, searchParams) {
            context.commit('updateSearchParams', searchParams)
        },
        async setPaymentSession (context, sessionUpdateResponse) {
            context.commit('setPaymentSession', sessionUpdateResponse)
        },
        async getPaymentSession (context, paymentSessionUrl) {
            return BookingService.getPaymentSession(paymentSessionUrl)
        },
        async setCancellationDetails (context, bookingId) {
            const response = await BookingService.getCancellationDetails(bookingId)
            context.commit('setCancellationDetails', response.data)
            return response.data
        },
        async cancelBooking (context, [bookingId, parkings, extras, channelBundles, forceCancel]) {
            let request = {
                forceCancel: forceCancel,
                parkings: parkings,
                extras: extras,
                channelBundles: channelBundles
            }
            return BookingService.cancelBooking(bookingId, request).then((response) => {
                context.commit('setCancellationDetails', null)
                return response
            }).catch((error) => {
                return error.response
            })
        },
        async refundBooking (context, refundModel) {
            return BookingService.refundBooking(refundModel.bookingId, refundModel).then((response) => {
                return response
            }).catch((error) => {
                return error.response
            })
        },
        async overridePrice (context, [bookingId, price]) {
            return BookingService.overrideBookingPrice(bookingId, price).then((response) => {
                context.commit('setOverridePrice', price)
                return response
            }).catch((error) => {
                return error.response
            })
        },
        async setOverrideParkingPrice (context, price) {
            context.commit('setOverrideParkingPrice', price)
        },
        async resetOverrideParkingPrice (context) {
            context.commit('resetOverridePrice')
            context.commit('setOverrideParkingPrice', 0)
        },
        async getRefundDetails (context, bookingId) {
            return BookingService.getRefundDetails(bookingId).then((response) => {
                context.commit('setRefundDetails', response.data)
                return response
            }).catch((error) => {
                return error.response
            })
        }
    }
}
